<template>
  <div class="wb-sidebar-menu-item"
       @dragstart="$emit('dragstartCustom', {e: $event, img: imgEl, data: data})"
       draggable="true"
       :class="{
        'wb-sidebar-menu-item-active': false, //TODO
        'wb-sidebar-menu-item-disabled': false //TODO
    }">
    <SVGClose class="wb-sidebar-menu-close" v-on:click="deleteElement" v-if="componentType==='3'"/>
    <img class="wb-sidebar-menu-item-img" :src="img" draggable="false" ref="imgEl"/>
    <div class="wb-sidebar-menu-item-data">
      <div class="wb-sidebar-menu-item-label">
        {{ label }}
      </div>
      <div class="wb-sidebar-menu-item-text" v-if="componentType!=='5'">
        {{ text }}
      </div>
        <SidebarMenuItemBot1 :price="price" :currencySymbol="this.currencySymbol" v-if="componentType === '1'"/>
        <SidebarMenuItemBot2
            :count="data.count"
            :data="data"
            :price="price"
            :currencySymbol="this.currencySymbol"
            v-if="componentType === '2'"
        />
        <SidebarMenuItemBot3
            :count="data.count"
            :data="data"
            :price="price"
            :currencySymbol="this.currencySymbol"
            v-if="componentType === '3'"
        />
        <SidebarMenuItemBot4 :price="price" :count="data.count" :currencySymbol="this.currencySymbol" v-if="componentType === '4'"/>
        <SidebarMenuItemBot5 v-if="componentType === '5'"/>
    </div>
  </div>
</template>

<script>
import SidebarMenuItemBot1 from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemBot1.vue';
import SidebarMenuItemBot2 from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemBot2.vue';
import SidebarMenuItemBot3 from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemBot3.vue';
import SidebarMenuItemBot4 from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemBot4.vue';
import { getImageHandler, getStaticImage } from '@/lib/getImage';
import { useStoreData } from '@/Store/storeData';
import { ref } from 'vue';
import { categoriesSectionsKeys } from '@/Constants/common';
import SVGClose from '@/UI/Components/SVG/SVGClose.vue';
import SidebarMenuItemBot5 from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItemBot5.vue';
import { removeAllSeparators, removeAllAccessoriesByBlenderName } from '@/lib/addShelfAccessories';

export default {
  name: 'SidebarMenuItem',
  components: {
      SidebarMenuItemBot5,
    SVGClose,
    SidebarMenuItemBot4,
    SidebarMenuItemBot3,
    SidebarMenuItemBot2,
    SidebarMenuItemBot1,
  },
  setup() {
    const storeData = useStoreData();
    const imgEl = ref(null);
    return {
      storeData,
      imgEl,
    };
  },
  inject: [ 'currencySymbol' ],
  props: [
    'data',
    'idArr',
    'componentType',
  ],
  computed: {
    label() {
      if (this.data.name) {
        return this.data.name;
      }
      return 'Label ';
    },
    text() {
      if (this.data) {
        return 'ВxШxГ, мм: ' +
            Math.ceil(+this.data.height * 1000) + 'x' +
            Math.ceil(+this.data.width * 1000) + 'x' +
            Math.ceil(+this.data.depth * 1000);
      }
      return 'Нет данных';
    },
    price() {
      if (this.data.price) {
        return this.data.price;
      }
      return '0';
    },
    img() {
      if (categoriesSectionsKeys[this.storeData.getActiveCategoriesSection] === 'catalog') {
        return getImageHandler(this.data.priview);
      } else {
        return getStaticImage(this.data.priview);
      }
    },
  },
  methods: {
    setDnDElement(event) {
      this.storeData.setDnDElement(this.data, event.clientX, event.clientY);
    },
    deleteElement() {
      if (this.data.blender_name === 'gpd_40_10' || this.data.blender_name === 'gpd_30_10') {
        removeAllSeparators();
      }

      const accessoryKeywords = [
        'Панель с крючками боковая',
        'Полка боковая',
        'Вешало торцевое',
      ];

      const isAccessory = accessoryKeywords.some((keyword) => this.data.name.includes(keyword));

      if (isAccessory && this.data.blender_name) {
        removeAllAccessoriesByBlenderName(this.data.blender_name);
      }

      this.storeData.removeItemFromCart(this.data.id);
    },
  },

};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/common.scss";
//@import "CSS/animations.scss";

.wb-sidebar-menu-item {
  position: relative;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  color: $darkBlue;
  @include wb-c-flex-center-start;
}

.wb-sidebar-menu-close {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  background-color: var(--grey-1, #F4F4F4);
}

.wb-sidebar-menu-item:hover {
  outline: 2px solid $green1;
}

.wb-sidebar-menu-item-active {
  outline: 2px solid $green1 !important;
}

.wb-sidebar-menu-item-disabled {
  opacity: 0.2 !important;
  outline: none !important;
  cursor: not-allowed !important;
}

.wb-sidebar-menu-item-img {
  user-select: none;
  width: 80px;
  height: 80px;
  object-fit: contain;
  flex-shrink: 0;

  //TODO temp
  background-color: #00000010;
}

.wb-sidebar-menu-item-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  text-align: start;
  width: 100%;
}

.wb-sidebar-menu-item-label {
  @include font-t2b;
  text-align: start;
}

.wb-sidebar-menu-item-text {
  @include font-t2;
  text-align: start;
}
</style>
